import Application from "../../Application";
import EvaluationPresenter, {
  IEvaluationPresenter
} from "../../presenter/evaluation/EvaluationPresenter";
import { IEvaluationService } from "../../service/evaluation/EvaluationService";
import { INotificationService } from "../../service/notification/NotificationService";
import { IEvaluationReview } from "../../model/evaluation/EvaluationReview";
import { IEvaluationRuleGroup } from "../../model/evaluation/EvaluationRuleGroup";
import { IEvaluationBusinessRule } from "../../model/evaluation/EvaluationBusinessRule";
import { IApplicantService } from "../../service/applicant/ApplicantService";
import { IRegisteredApplicant } from "../../model/applicant/RegisteredApplicant";

export default class ShowEvaluationPageInteractor {
  private application: Application;
  private output?: IEvaluationPresenter;
  private evaluationService: IEvaluationService;
  private notificationService: INotificationService;
  private applicantService: IApplicantService;

  constructor(
    application,
    evaluationService,
    notificationService,
    applicantService
  ) {
    this.application = application;
    this.evaluationService = evaluationService;
    this.notificationService = notificationService;
    this.applicantService = applicantService;
  }

  async getEvaluationReviews(evaluationId: number) {
    try {
      return this.evaluationService.getEvaluationReviews(evaluationId);
    } catch (error) {
      this.notificationService.showError((error as any).message);
    }
  }

  async getData(evaluationId: number, applicantId: number) {
    const [evaluationReviews, applicant] = await Promise.all([
      this.getEvaluationReviews(evaluationId),
      this.applicantService.getRegisteredApplicants(applicantId)
    ]);
    return { evaluationReviews, applicant };
  }

  execute(evaluationId: number, applicantId: number) {
    this.output = EvaluationPresenter({
      application: this.application,
      initialState: {
        evaluationReviews: [] as IEvaluationReview[],
        evaluationRuleGroups: [] as IEvaluationRuleGroup[],
        evaluationBusinessRules: [] as IEvaluationBusinessRule[],
        applicant: {} as IRegisteredApplicant
      }
    });

    this.getData(evaluationId, applicantId).then((result) =>
      this.output?.setEvaluationReviews(
        result.evaluationReviews || [],
        result.applicant && result.applicant[0]
      )
    );

    return this.output;
  }
}
